export default () => {
    const registration = document.querySelector(".in-registrace") || document.querySelector('.in-registration');

    if (registration) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const wholesale = urlParams.get("wholesale");

        if (wholesale == 1) {
            $("#wholesale").click();
        }

        const consents = registration.querySelector('.consents');

        if (consents) {
            const isEN = shoptet.cookie.get("language") === "en";

            const registrationAgreement = consents.querySelector('label[for="consents28"]');

            if (isEN) {
                registrationAgreement.innerHTML = 'By clicking you agree to the <a href="/obchodni-podminky/" rel="noopener noreferrer">terms and conditions</a> and <a href="/podminky-ochrany-osobnich-udaju/" rel="noopener noreferrer">privacy policy</a>'
            }
        }

        const companiIdField = registration.querySelector("#additionalInformation #company-info #companyId");

        if (companiIdField) {
            var $companyIdDiv = $("#additionalInformation #company-info #companyId").parent();
            $companyIdDiv.addClass('form-group-hasTooltip');

            var tooltipText = 'A CIN is a numeric, 8-digits maximum number allotted to the company on the date of its registration by the Registrar of Companies.';
            var $companyTooltipIcon = $("<span/>", {
                'aria-hidden': 'true',
                'data-original-title': tooltipText,
                class: 'show-tooltip question-tooltip form-group-tooltip',
                text: '?',
                title: ''
            }).tooltip();

            var $cinDescription = $('<span/>', {
                class: 'sr-only',
                id: 'companyid-description',
                text: tooltipText
            });

            var $companyIdInput = $("#additionalInformation #company-info #companyId");
            $companyIdInput.attr('aria-describedby', 'companyid-description').attr('placeholder', '12345678');

            $companyIdDiv.append($companyTooltipIcon);
            $companyIdDiv.append($cinDescription);
        }
    }
};